import React, { useState } from "react";
import { cardMap } from "./model";

const ORDER = [["Approvals", /approv/i], ["Language", /lang/i], ["Audits", /audit/i], ["His tasks", /task/i]];
const BTNS = [["Approve", "approve"], ["Correct", "correct", true], ["Send back", "send back"], ["Not mine", "not mine"]];
const P = "21_eshan_reviews";

function groupOf(kind) {
  const hit = ORDER.find(([, re]) => re.test(kind || ""));
  return hit ? hit[0] : kind || "Other";
}

function ReviewRow({ r, ctx, nav, card }) {
  const [fix, setFix] = useState(false);
  const [t, setT] = useState("");
  const pressed = ctx.pressedFor(P, r.id);
  return (
    <div className={`rev${pressed ? " pressed" : ""}`} data-testid={`review-${r.id}`}>
      <div className="rev-t">
        <span>{r.title}</span>
        {card?.topic && <span className="chip tchip" data-testid={`review-topic-${r.id}`}>{card.topic}</span>}
        {card?.age && <span className="faint small" data-testid={`review-age-${r.id}`}>{card.age}</span>}
        {r.card_id && <a className="rev-link" href={`/card/${r.card_id}`} data-testid={`review-link-${r.id}`}
          onClick={(e) => { e.preventDefault(); nav(`/card/${r.card_id}`); }}>Open card ›</a>}
      </div>
      <div className="acts">
        {BTNS.map(([label, action, needsText], i) => (
          <button key={action} className={`btn${i === 0 ? " primary" : ""}`} disabled={!ctx.canAct}
            data-testid={`review-${r.id}-${action.replace(/\s+/g, "-")}`}
            onClick={() => (needsText ? setFix(!fix) : ctx.act(P, action, r.id, "", r.kind || ""))}>{label}</button>
        ))}
      </div>
      {fix && (
        <div className="moves-extra">
          <input className="vinput" placeholder="The corrected words, one line" value={t} onChange={(e) => setT(e.target.value)} data-testid={`review-${r.id}-correct-input`} />
          <button className="btn primary" disabled={!t.trim()} data-testid={`review-${r.id}-correct-confirm`}
            onClick={() => { ctx.act(P, "correct", r.id, t.trim(), r.kind || ""); setFix(false); setT(""); }}>Queue</button>
        </div>
      )}
    </div>
  );
}

export function Reviews({ data, ctx, nav }) {
  const cards = cardMap(data?.board);
  const rows = data?.panels?.[P]?.rows;
  if (!Array.isArray(rows) || rows.length === 0) {
    return <div className="reviews" data-testid="reviews-page"><p className="rev-empty" data-testid="reviews-empty">No reviews on the board yet</p></div>;
  }
  const groups = {};
  rows.forEach((r) => { const g = groupOf(r.kind); (groups[g] = groups[g] || []).push(r); });
  const names = [...ORDER.map(([n]) => n), ...Object.keys(groups).filter((g) => !ORDER.some(([n]) => n === g))].filter((g) => groups[g]);
  return (
    <div className="reviews" data-testid="reviews-page">
      <h1 className="greet">Eshan's reviews</h1>
      {names.map((g) => (
        <section className="sec" key={g} data-testid={`reviews-group-${g.replace(/\s+/g, "-")}`}>
          <div className="sec-h"><h2>{g}</h2><span className="counts">{groups[g].length}</span></div>
          {groups[g].map((r) => <ReviewRow key={r.id} r={r} ctx={ctx} nav={nav} card={cards[r.card_id]} />)}
        </section>
      ))}
    </div>
  );
}
